import { generateTestId } from "@client-shared";

export const setReviewSuccessTestId = (identifier: string): string => generateTestId("ReviewSuccess", identifier);

export const setReviewSuccessIconTestId = (identifier: string): string => generateTestId("ReviewSuccessIcon", identifier);

export const setReviewSuccessTitleTestId = (identifier: string): string => generateTestId("ReviewSuccessTitle", identifier);

export const setReviewSuccessDescriptionTestId = (identifier: string): string => generateTestId("ReviewSuccessDescription", identifier);

export const setReviewSuccessRedirectingTestId = (identifier: string): string => generateTestId("ReviewSuccessRedirecting", identifier);

export const setReviewSuccessBadgeTestId = (identifier: string): string => generateTestId("ReviewSuccessBadge", identifier);

export const setReviewSuccessImportMoreTestId = (identifier: string): string => generateTestId("ReviewSuccessImportMore", identifier);

export const setReviewSuccessExitTestId = (identifier: string): string => generateTestId("ReviewSuccessExit", identifier);
